 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"0c428ae2","2":"1bfc9850","3":"78e521c3","4":"30fe5762e4dd86b1b491c7165343fe209a82e007","5":"777cf710","6":"95b64a6e","7":"9ea93d7a7504ebfdaac0adc82285a114c5a7e867","8":"8aad1d24fdf42d8c4cc6b9a0b4308c1a897a8f02","9":"2c796e83","10":"8f6dbe257d051671eb27f031d0681a4ae92a96cb","11":"a0f3ea3cbd94ca4be367dcdf262bd9a70e9e7a24","12":"b48c3ed15e4982d06f50a08b605e6b2e70d8e261","13":"bcc1f5460d0803a3a5f7d36118ec3b44e95f5284","16":"component---src-pages-404-js","17":"component---src-pages-about-js","18":"component---src-pages-cobb-infocus-js","19":"component---src-pages-diverse-power-js","20":"component---src-pages-gea-js","21":"component---src-pages-habersham-medical-center-js","22":"component---src-pages-in-person-ltc-learning-20210812-js","23":"component---src-pages-in-person-ltc-learning-20210922-js","24":"component---src-pages-index-js","25":"component---src-pages-long-term-care-articles-article-item-js","26":"component---src-pages-long-term-care-articles-index-js","27":"component---src-pages-long-term-care-facts-myths-js","28":"component---src-pages-long-term-care-group-insurance-js","29":"component---src-pages-long-term-care-info-index-js","30":"component---src-pages-long-term-care-info-media-item-js","31":"component---src-pages-long-term-care-insurance-advice-videos-index-js","32":"component---src-pages-long-term-care-insurance-advice-videos-video-item-js","33":"component---src-pages-long-term-care-insurance-companies-js","34":"component---src-pages-long-term-care-insurance-cost-js","35":"component---src-pages-long-term-care-insurance-providers-podcast-index-js","36":"component---src-pages-long-term-care-insurance-providers-podcast-podcast-item-js","37":"component---src-pages-long-term-care-insurance-quote-js","38":"component---src-pages-long-term-care-insurance-specialist-js","39":"component---src-pages-long-term-care-planning-js","40":"component---src-pages-long-term-care-webinar-js","41":"component---src-pages-long-term-health-care-js","42":"component---src-pages-mba-pas-js","43":"component---src-pages-privacy-policy-js","44":"component---src-pages-rppt-seminar-dec-2021-sband-js","45":"component---src-pages-survey-js","46":"component---src-pages-thank-you-js","47":"component---src-pages-the-villages-js","48":"component---src-templates-blog-js","49":"component---src-templates-podcast-js","50":"component---src-templates-video-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"821c60f4f6a7f50db570","2":"9658ee3b7cfe6954c988","3":"a9df5d8c30b117dae937","4":"83508d7c525ba29be4f1","5":"2e86d5cbca0421ec2544","6":"4ac33d7ed89a3a3f601f","7":"85250bdfb1669726b839","8":"9dd743502875a9e283a6","9":"e13a44ae3c302377da06","10":"a2cc3c9b02495c7ad9e4","11":"979550e229bddd40628a","12":"3d171810b459d9e34564","13":"8cbb22cf2ebddf8528ba","16":"bfbacd642b733d37e8e9","17":"9d42aa4946fde4ff366b","18":"074a4d64179206d7e5dd","19":"398d319fdccbe50a6c94","20":"be5d1d0868584382ce46","21":"c725db86d9689f1c6eca","22":"ea5dbf097cf7bb476f3a","23":"ce10bb95062965ae7cb1","24":"29b68c876898a8f8e103","25":"03dcf5d5e500c9877153","26":"07a0c7b29caea08e0659","27":"2388660325763f6c8159","28":"af7da075f615020fd4c3","29":"144d3bcf9683458d8c67","30":"99a5c91fe105fb93355c","31":"9c29f8646bfad042de59","32":"cd54a3e97af187316c6f","33":"5ec116829af02ddc3d74","34":"ed47eb7b2fa423edf745","35":"2fd38921a32c749f56d2","36":"35592e325e88ca6f0f22","37":"23de2feb076dee9c7c4a","38":"1a238d537964e6c8b351","39":"f72c020786cd75c783ae","40":"45d2279fa3c9046694c4","41":"23e8a806e0efdc137577","42":"b452582bcb417cf02301","43":"18484384ac3f4b1191e3","44":"47f7be926e1da6987c2d","45":"f048716b09aa7daa59a1","46":"4738524d0b38976e6cab","47":"bf83c73a3db9e105d0e4","48":"9afaf127c836bbb78860","49":"535bea8c2ba208c43ffb","50":"49094a87e41f80b8a0a8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"0c428ae2","2":"1bfc9850","3":"78e521c3","4":"30fe5762e4dd86b1b491c7165343fe209a82e007","5":"777cf710","6":"95b64a6e","7":"9ea93d7a7504ebfdaac0adc82285a114c5a7e867","8":"8aad1d24fdf42d8c4cc6b9a0b4308c1a897a8f02","9":"2c796e83","10":"8f6dbe257d051671eb27f031d0681a4ae92a96cb","11":"a0f3ea3cbd94ca4be367dcdf262bd9a70e9e7a24","12":"b48c3ed15e4982d06f50a08b605e6b2e70d8e261","13":"bcc1f5460d0803a3a5f7d36118ec3b44e95f5284","16":"component---src-pages-404-js","17":"component---src-pages-about-js","18":"component---src-pages-cobb-infocus-js","19":"component---src-pages-diverse-power-js","20":"component---src-pages-gea-js","21":"component---src-pages-habersham-medical-center-js","22":"component---src-pages-in-person-ltc-learning-20210812-js","23":"component---src-pages-in-person-ltc-learning-20210922-js","24":"component---src-pages-index-js","25":"component---src-pages-long-term-care-articles-article-item-js","26":"component---src-pages-long-term-care-articles-index-js","27":"component---src-pages-long-term-care-facts-myths-js","28":"component---src-pages-long-term-care-group-insurance-js","29":"component---src-pages-long-term-care-info-index-js","30":"component---src-pages-long-term-care-info-media-item-js","31":"component---src-pages-long-term-care-insurance-advice-videos-index-js","32":"component---src-pages-long-term-care-insurance-advice-videos-video-item-js","33":"component---src-pages-long-term-care-insurance-companies-js","34":"component---src-pages-long-term-care-insurance-cost-js","35":"component---src-pages-long-term-care-insurance-providers-podcast-index-js","36":"component---src-pages-long-term-care-insurance-providers-podcast-podcast-item-js","37":"component---src-pages-long-term-care-insurance-quote-js","38":"component---src-pages-long-term-care-insurance-specialist-js","39":"component---src-pages-long-term-care-planning-js","40":"component---src-pages-long-term-care-webinar-js","41":"component---src-pages-long-term-health-care-js","42":"component---src-pages-mba-pas-js","43":"component---src-pages-privacy-policy-js","44":"component---src-pages-rppt-seminar-dec-2021-sband-js","45":"component---src-pages-survey-js","46":"component---src-pages-thank-you-js","47":"component---src-pages-the-villages-js","48":"component---src-templates-blog-js","49":"component---src-templates-podcast-js","50":"component---src-templates-video-js"}[chunkId]||chunkId) + "." + {"0":"965ded042c63f596d118","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
